export const DEFAULT_VALUES = {
  id: "table_pagination",
  page: 0,
  size: 10,
  total: 10
};

export const VALIDATE_KEY_VALUES = {
  page: true,
  size: true,
  total: true
};
